import { connect } from 'react-redux';
import partial from 'lodash/partial';
import idx from 'idx';
import { toggleTip, tip } from 'entries/ducks';
import { TIP_FEE } from 'entries/constants';
import TipModal from 'entries/components/tip_modal';

const mapStateToProps = (state) => {
  const { tippingEntry } = state.entries;
  const value = parseFloat(idx(state, _ => _.form.TipModal.values.value) || 0);
  const fee = value * TIP_FEE;

  return {
    entry: tippingEntry,
    total: value + fee,
    fee
  };
};

export default connect(mapStateToProps, {
  tip,
  onClose: partial(toggleTip, null)
})(TipModal);



// WEBPACK FOOTER //
// ./entries/containers/tip_modal.js